var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-snackbar',{attrs:{"md-position":"center","md-active":_vm.showSnackbar,"md-persistent":"","md-duration":4000},on:{"update:mdActive":function($event){_vm.showSnackbar=$event}}},[_vm._v("\n  "+_vm._s(_vm.snackbarText)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }